<template>
  <view-page
    :title="!loading ? selectedList.name : ''"
    permission-name="list"
    @editItem="editList"
    :edit-button="canEditList"
    :delete-button="false"
    :loading="loading"
  >
    <template v-slot:headerRightSide>
      <management-add-button
        v-if="canCreateNewListItem"
        :label="$t('AddItem')"
        @buttonClick="
          $router.push({
            name: 'list-settings-item-create',
            params: {
              listName: listName,
              isCustomList: selectedList.custom_list,
              list_id: selectedList.custom_list ? selectedList.id : null
            }
          })
        "
        :list-missing-permissions="[]"
      />
    </template>

    <template v-slot:leftSide>
      <view-page-data-field
        v-for="field in fields"
        :key="field.label"
        v-if="field.visible"
        :icon="field.icon"
        :label="field.label"
        :data="field.data"
        :hasPermission="field.hasPermission"
      />
    </template>

    <template v-slot:rightSide>
      <div class="management-section-wrapper">
        <list-info-data-table
          :listUuid="selectedList.uuid"
          :isCustomList="selectedList.custom_list"
        />
      </div>
    </template>
  </view-page>
</template>

<script>
import ManagementPageBackArrow from "../../../Management/ManagementPageBackArrow";
import ManagementAddButton from "@/components/Management/ManagementAddButton";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import ViewPage from "@/components/Management/ViewPage/ViewPage";
import ViewPageDataField from "@/components/Management/ViewPage/ViewPageDataField";
import ListInfoDataTable from "@/components/SystemManagement/SystemSettings/ListsSettings/ListItemTable";
import { mapActions } from "vuex";

export default {
  name: "ListInfo",

  components: {
    ViewPageDataField,
    ViewPage,
    ManagementAddButton,
    ManagementPageBackArrow,
    ListInfoDataTable
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      /**
       * Data of the selected list
       */
      selectedList: null,
      loading: true,

      /**
       * Fields for the information card
       */
      fields: null
    };
  },

  computed: {
    /**
     * Indicates if a user can edit the list or not
     * @return {Boolean}
     */
    canEditList() {
      let hasPermission = false;
      if(this.selectedList){
        //if custom list, only admin with permission and superadmin can edit
        //if not custom, only superAdmin can edit
        if(this.selectedList.custom_list){
          if(this.isSuperAdmin){
            hasPermission = true;
          }else{
            hasPermission = this.userHasManagementPermission("custom_list", "update") && this.isAdmin;
          }
        }else{
          hasPermission = this.isSuperAdmin;
        }
      }
      return hasPermission;
    },
    /**
     * Indicates if the user can create a new list item
     * @return {Boolean}
     */
    canCreateNewListItem() {
      return this.userHasManagementPermission("list_item", "store");
    },

    /**
     * Gets the name of the list from the route parameters and returns it
     * @return {String}
     */
    listName() {
      return this.$route.params.listName;
    }
  },

  mounted() {
    this.fetchListByListName();
  },

  methods: {
    ...mapActions(["GET_LIST", "GET_LIST_OF_LISTS"]),

    /**
     * Get the list by its name and asks for the fields to be loaded
     */
    async fetchListByListName() {
      try {
        let code = this.listName;
        let result = await this.GET_LIST_OF_LISTS();
        let lists = result.data.data;
        if (this.listName !== "list_projections") {
          code = this.listName.replace("list_", "l_");
        }

        this.selectedList = lists.find(list => list.code === code);
        this.fields = this.getFields();
        //await this.fetchListByListName();
      } catch (error) {
        console.error(error);
        this.$router.replace("/error");
      } finally {
        this.loading = false;
      }
    },

    /**
     * Return the fields for the information card
     * The field Code is only returned if the user is a Super Admin
     * @return {Array}
     */
    getFields() {
      let fields = [];
      if (this.isSuperAdmin) {
        fields.push({
          icon: "code",
          label: this.$i18n.tc("Code", 1),
          data: this.selectedList.code,
          visible: true
        });
      }
      fields.push(
        {
          icon: "label",
          label: this.$i18n.t("Name"),
          data: this.selectedList.name,
          visible: true
        },
        {
          icon: "label",
          label: this.$i18n.t("ClientLabel"),
          data: this.selectedList.client_label
            ? this.selectedList.client_label
            : this.$i18n.t("NotAvailable"),
          visible: true
        },
        {
          icon: "hide_source",
          label: this.$i18n.t("Hidden"),
          data: this.selectedList.hidden
            ? this.$i18n.t("Yes")
            : this.$i18n.t("No"),
          visible: this.isSuperAdmin
        },
        {
          icon: "tune",
          label: this.$i18n.t("Custom"),
          data: this.selectedList.custom_list
            ? this.$i18n.t("Yes")
            : this.$i18n.t("No"),
          visible: true
        },
        {
          icon: "subject",
          label: this.$i18n.t("Definition"),
          data:
            this.selectedList.definition && this.selectedList.definition !== ""
              ? this.selectedList.definition
              : this.$i18n.t("NotAvailable"),
          visible: true
        }
      );
      return fields;
    },

    /**
     * Redirects to the edit page, passing the list name and a variable indicating if it's a custom list as parameters of the route
     */
    editList() {
      if(this.selectedList.custom_list){
        this.$router.push({
          name: "custom-list-setting-edit",
          params: {
            listName: this.listName,
          }
        });
      }else{
        this.$router.push({
          name: "list-setting-edit",
          params: {
            listName: this.listName,
            isCustomList: this.selectedList.custom_list
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/ListInfo.vue